import React from 'react'

function Forbidden() {
  return (
    <>
    <div className="page-wrap d-flex flex-row align-items-center">
    <div className="container">
        <div className="row justify-content-center">
            <div className="col-md-12 text-center">
                <span className="display-1 d-block">403 Forbidden</span>
                <div className="mb-4 lead">Access Not Granted</div>
                <a className="btn btn-danger" href="javascript:history.back()">Go Back</a>
            </div>
        </div>
    </div>
</div>
     
    </>
  )
}

export default Forbidden